import React from 'react';
import { Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="contacto" className="py-24 bg-gray-50" data-id="element-51">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-52">
        <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-53">
          Contacto
        </h2>
        <h3 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-54">
          Hablemos de tu proyecto
        </h3>
        <p className="text-lg text-gray-600 mb-12" data-id="element-55">
          ¿Listo para transformar la manera en que procesas pagos y recaudas?
          Nuestro equipo de expertos está listo para ayudarte a diseñar la
          solución perfecta.
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto" data-id="element-56">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-57">
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-58">
              <Mail className="w-6 h-6 text-zumpago-red" data-id="element-59" />
            </div>
            <h4 className="font-bold text-gray-900 text-lg mb-2" data-id="element-60">
              Ventas y Comercial
            </h4>
            <a href="mailto:ventas@zumpago.com" className="text-zumpago-red font-medium hover:underline transition-colors" data-id="element-61">
              ventas@zumpago.com
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-62">
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-63">
              <Mail className="w-6 h-6 text-zumpago-red" data-id="element-64" />
            </div>
            <h4 className="font-bold text-gray-900 text-lg mb-2" data-id="element-65">
              Consultas y Atención al Cliente
            </h4>
            <a href="mailto:contacto@zumpago.com" className="text-zumpago-red font-medium hover:underline transition-colors" data-id="element-66">
              contacto@zumpago.com
            </a>
          </div>
        </div>
      </div>
    </section>;
}